import { render, staticRenderFns } from "./ChessBoard.vue?vue&type=template&id=7e6483af&"
import script from "./ChessBoard.vue?vue&type=script&lang=ts&"
export * from "./ChessBoard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports